import { Footer } from "@/components/Footer";
import { Header } from "@/components/Header";
import { Toaster } from "@/components/ui/sonner";
import type { QueryClient } from "@tanstack/react-query";
import { createRootRouteWithContext, Outlet } from "@tanstack/react-router";

export interface RouterContext {
  auth: {
    initialized: boolean;
    authenticated: boolean;
    user: { name?: string; email?: string; sub?: string } | null;
    roles: string[];
    token: string | undefined;
    login: () => void;
    logout: () => void;
  };
  queryClient: QueryClient;
}

export const Route = createRootRouteWithContext<RouterContext>()({
  component: RootComponent,
});

function RootComponent() {
  return (
    <div className="flex min-h-screen flex-col">
      <Header />
      <main className="flex-1">
        <Outlet />
        <Toaster />
      </main>
      <Footer />
    </div>
  );
}
